(function () {
  const MQ_DESKTOP = window.matchMedia('(min-width: 750px)');

  function initCarousel(root) {
    if (!root || root.dataset.wtReady === 'true') return;

    const track = root.querySelector('.written-testimonials__track');
    const viewport = root.querySelector('.written-testimonials__viewport');
    const prevBtn = root.querySelector('[data-wt-prev]');
    const nextBtn = root.querySelector('[data-wt-next]');
    if (!track || !viewport) return;

    const items = () => Array.from(track.querySelectorAll('.written-testimonials__item'));
    const columnsDesktop = parseInt(root.dataset.columnsDesktop || '3', 10);
    const columnsMobile = parseInt(root.dataset.columnsMobile || '1', 10);

    let index = 0;

    function perView() {
      return MQ_DESKTOP.matches ? columnsDesktop : columnsMobile;
    }

    function maxIndex() {
      return Math.max(0, items().length - perView());
    }

    function gap() {
      const styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap) || 0;
    }

    function stepSize() {
      const list = items();
      if (!list.length) return 0;
      return list[0].getBoundingClientRect().width + gap();
    }

    function goTo(nextIndex) {
      const list = items();
      if (!list.length) return;

      index = Math.min(Math.max(nextIndex, 0), maxIndex());

      const offset = index * stepSize();
      const isRtl = document.documentElement.getAttribute('dir') === 'rtl';

      track.style.transform = `translate3d(${isRtl ? offset : -offset}px, 0, 0)`;

      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= maxIndex();
    }

    function onPrev() {
      goTo(index - 1);
    }

    function onNext() {
      goTo(index + 1);
    }

    function onResize() {
      goTo(Math.min(index, maxIndex()));
    }

    prevBtn?.addEventListener('click', onPrev);
    nextBtn?.addEventListener('click', onNext);
    window.addEventListener('resize', onResize);
    MQ_DESKTOP.addEventListener('change', onResize);

    root.dataset.wtReady = 'true';
    goTo(0);

    if (Shopify.designMode) {
      root.addEventListener('shopify:block:select', (event) => {
        const selected = event.target.closest('.written-testimonials__item');
        const list = items();
        const selectedIndex = list.indexOf(selected);
        if (selectedIndex >= 0) goTo(selectedIndex);
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-wt-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:reorder', () => initAll());
})();
